import { CatalogProcessor } from './CatalogProcessor';
import { validateJsonObject } from "Core/data/Helpers";

export class Asset {

  constructor() {
    this.boundGetProcessItem = this.getProcessItem.bind(this);
  }

  executeArray = (items, itemsExists) => {
    return CatalogProcessor.executeArray(
      items, 
      itemsExists, 
      'assets', 
      this.boundGetProcessItem, 
      'label' //order by label
    );
  }

  execute = (item, itemsExists) => {
    return CatalogProcessor.execute(
      item, 
      itemsExists, 
      'assets', 
      this.boundGetProcessItem, 
      'label'
    );
  }

  getProcessItem = (item, newItem, itemsExists) => {
    let tags = item?.tags || [];
    let tagIds = item?.tagIds || '';

    // Priority 1: If newItem has tags array, use it directly
    if (newItem?.tags && Array.isArray(newItem?.tags)) {
      tags = newItem?.tags;
      tagIds = newItem?.tagIds !== undefined ? newItem?.tagIds : item?.tagIds;
    } 
    // Priority 2: If newItem has tagIds, reconstruct tags from catalog
    else if (newItem?.tagIds !== undefined) {
      tagIds = newItem.tagIds;
      tags = CatalogProcessor.reconstructTagsFromIds(tagIds, itemsExists || {});
    }

    const assetType = newItem?.assetType ? {
      entityId: newItem.assetType.entityId,
      label: newItem.assetType.label
    } : item?.assetType || null;

    // Simplified assetSubtype handling
    const assetSubtype = newItem?.assetSubtype ? {
      id: newItem.assetSubtype.id,
      name: newItem.assetSubtype.name
    } : item?.assetSubtype || null;

    return {
      ...item,
      id: newItem.id || item.id,
      label: newItem.label || item.label,
      unitId: newItem.unitId || item.unitId,
      assetTypeId: newItem.assetTypeId !== undefined ? newItem.assetTypeId : item.assetTypeId,
      assetType,
      assetSubtypeId: newItem.assetSubtypeId !== undefined ? newItem.assetSubtypeId : item.assetSubtypeId,
      assetSubtype,
      vin: newItem.vin || item.vin,
      ecuVin: newItem.ecuVin || item.ecuVin,
      make: newItem.make !== undefined ? newItem.make : item.make,
      model: newItem.model !== undefined ? newItem.model : item.model,
      year: newItem.year !== undefined ? newItem.year : item.year,
      engine: newItem.engine !== undefined ? newItem.engine : item.engine,
      mpgHighway: newItem.mpgHighway !== undefined ? newItem.mpgHighway : item.mpgHighway,
      mpgCity: newItem.mpgCity !== undefined ? newItem.mpgCity : item.mpgCity,
      licensePlate: newItem?.licensePlate || item?.licensePlate,
      registrationState: newItem?.registrationState || item?.registrationState,
      registrationCountry: newItem?.registrationCountry || item?.registrationCountry,
      registrationExpiration: newItem?.registrationExpiration || item?.registrationExpiration,
      inspectionDeviceType: newItem?.inspectionDeviceType || item?.inspectionDeviceType,
      inspectionTagId: newItem?.inspectionTagId !== undefined ? newItem?.inspectionTagId : item?.inspectionTagId,
      powerUnitNumber: newItem?.powerUnitNumber || item?.powerUnitNumber,
      externalId: newItem?.externalId || item?.externalId,
      isActive: newItem?.isActive !== undefined ? newItem?.isActive : item?.isActive,
      chassisSerialNumber: newItem?.chassisSerialNumber || item?.chassisSerialNumber,
      engineSerialNumber: newItem?.engineSerialNumber || item?.engineSerialNumber,
      maintenanceCompany: newItem?.maintenanceCompany !== undefined ? newItem?.maintenanceCompany : item?.maintenanceCompany,
      tagIds,
      tags
    }
  }

}